import { useLocation, useNavigate } from "react-router-dom";
import DDxInputSelectorBg from "./../../../../assets/images/ddx-input-selector-bg.webp";
import successAnimation from "./../../../../assets/images/success-animation.webp";
import calendar from "./../../../../assets/images/calender-outline.svg";
import profile from "./../../../../assets/images/profile-outline.svg";
import location from "./../../../../assets/images/location.svg";
import googleLocationIcon from "./../../../../assets/images/google-location.svg";
import calenderEdit from "./../../../../assets/images/calendar-edit.svg";
import cross from "./../../../../assets/images/cross.svg";
import arrowRight from "./../../../../assets/images/arrow-white.svg";
import close from "./../../../../assets/images/close-outline.svg";
import dayjs from "dayjs";
import { calculateAge, trackEvent } from "../../../../utils/helper";
import { useState, useEffect } from "react";
import CancelConfirmation from "../cancelConfirmation/CancelConfirmation";
import { ValidLanguages } from "../../../symptomCollector/utils/types";
import {
  JWT_TOKEN,
  LangSpecificMsg,
  LANGUAGE,
  TYPE,
} from "../../../symptomCollector/utils/constants";
import { getLocalStorage } from "../../../../utils/localStorage";

const SuccessAppointment = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const selectedLanguage = getLocalStorage(LANGUAGE);
  const LangSpecificMsgData =
    LangSpecificMsg[(selectedLanguage as ValidLanguages) || "english"];

  const {
    pm_first_name,
    patient_name,
    name,
    pm_gender,
    gender,
    patients_gender,
    pm_dob,
    patients_dob,
    date_of_birth,
    pm_pid,
    doctor_name,
    um_name,
    doctors_name,
    appointment_date,
    appointment_start_time,
    symptomsCollectorLink,
    agentDetails,
    um_id,
    doctor_speciality,
    type,
  } = state || {};

  const { hospital_name, googleLocation, patient_contact_no, hm_id } =
    agentDetails || {};

  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(true);

  const patientAge = calculateAge(pm_dob || patients_dob || date_of_birth);

  const { address } = googleLocation || {};

  const { formatted, googleMapsLink } = address || {};

  // Effect to reduce animation size after 2 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFullScreen(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  function getAppointmentDayLabel(appointment_date: string) {
    const today = dayjs().format("YYYY-MM-DD");
    const tomorrow = dayjs().add(1, "day").format("YYYY-MM-DD");
    if (appointment_date === today) return "Today, ";
    if (appointment_date === tomorrow) return "Tomorrow, ";
    return "";
  }

  const appointmentDayLabel = getAppointmentDayLabel(appointment_date);

  const moengageData = {
    "Login Mobile No": patient_contact_no,
    "Clinic Id": hm_id,
    "Clinic Name": hospital_name,
    "Time Stamp": dayjs().format("YYYY-MM-DD HH:mm:ss"),
    "Owner Doctor Name": doctor_name || doctors_name || um_name,
    "Owner Doctor Specialty": doctor_speciality,
    "Owner Doctor Unique ID": um_id,
    "Patient Name": pm_first_name || patient_name || name || "",
    "Patient Id": pm_pid,
    "Patient Age": patientAge.years,
    "Patient Gender": pm_gender || gender,
  };

  return (
    <div className="App symptom-collector relative min-h-screen">
      {/* Background Image */}
      <div className="fixed inset-0">
        <img
          src={DDxInputSelectorBg}
          alt="bg"
          className="h-full w-full object-cover opacity-5"
        />
      </div>

      <div className="relative z-10 flex flex-col items-center py-8 px-4">
        {/* Close Icon */}
        {!isFullScreen && (
          <div
            className="absolute top-4 left-4 cursor-pointer"
            onClick={() => {
              const jwtToken = getLocalStorage(JWT_TOKEN);
              navigate(`/appointment-booking?jwtToken=${jwtToken}`);
            }}
          >
            <img src={close} alt="close" className="w-6 h-6" />
          </div>
        )}

        {/* Success Check - Full screen for 2 seconds, then reduces */}
        <img
          src={successAnimation}
          alt="success"
          className={`transition-all duration-2000 ease-in-out ${
            isFullScreen
              ? "max-w-[450px] mx-auto w-full h-full fixed inset-0 z-50 object-contain"
              : "w-20 h-20"
          }`}
        />

        {!isFullScreen && (
          <>
            {/* Success Text */}
            <h1 className="text-lg font-medium text-center mb-4">
              {LangSpecificMsgData.successAppoinment}
            </h1>

            {/* Appointment Card */}
            <div className="bg-white rounded-2xl px-6 py-4 w-full shadow-sm mb-4">
              <div className="flex items-center gap-2 mb-4">
                <img src={profile} alt="profile" />
                <span className="text-sm font-medium">
                  {pm_first_name || patient_name || name} (
                  {pm_gender || patients_gender || gender}, {patientAge.years}{" "}
                  yrs)
                </span>
              </div>

              <div className="flex items-center gap-2 mb-2">
                <img src={calendar} alt="calendar" />
                <span className="text-sm font-medium">
                  {appointmentDayLabel}
                  {dayjs(appointment_date).format("DD MMM YY")} |{" "}
                  {appointment_start_time}
                </span>
              </div>
              <div className="text-[#666666] text-xs ml-9 mt-[-8px]">
                With {doctor_name || doctors_name || um_name}
              </div>

              <div className="flex items-start gap-2 mt-4">
                <img src={location} alt="location" />
                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2 text-sm">
                    {hospital_name}
                    <img
                      src={googleLocationIcon}
                      alt="google-location"
                      onClick={() => window.open(googleMapsLink, "_blank")}
                    />
                  </div>
                  <div className="text-[#666666] text-xs">{formatted}</div>
                </div>
              </div>

              <div className="flex justify-center gap-6 mt-6">
                <button
                  className="py-3 border border-none rounded-xl text-[#E32222] flex items-center justify-center gap-2"
                  onClick={() => setShowCancelConfirmation(true)}
                >
                  <img src={cross} alt="cross" />
                  Cancel
                </button>
                <button
                  className="py-3 border border-none rounded-xl text-[#6B4DE0] flex items-center justify-center gap-2"
                  onClick={() => {
                    trackEvent("AA_Edit_Apt", moengageData);
                    navigate("/book-appointment", { state: state });
                  }}
                >
                  <img src={calenderEdit} alt="calender-edit" />
                  {LangSpecificMsgData.editAppoitment}
                </button>
              </div>
            </div>

            {/* Add Symptoms Section */}
            <div className="bg-white rounded-2xl px-6 py-4 w-full shadow-sm mb-6">
              <p className="text-center mb-3 text-sm">
                {LangSpecificMsgData.shareSymptomsInfo}
              </p>
              <button
                className="w-full bg-[#6B4DE0] text-white py-4 rounded-xl text-base font-medium flex items-center justify-center gap-2"
                onClick={() => {
                  trackEvent("AA_AddSymp_ConfScreen", moengageData);
                  sessionStorage.setItem(TYPE, type);
                  window.location.href = symptomsCollectorLink;
                }}
              >
                {LangSpecificMsgData.addSymptoms}
                <img src={arrowRight} alt="arrow-right" />
              </button>
            </div>

            {/* Go Home Link */}
            <button
              className="text-[#6B4DE0] font-medium underline"
              onClick={() => {
                const jwtToken = getLocalStorage(JWT_TOKEN);
                navigate(`/appointment-booking?jwtToken=${jwtToken}`);
              }}
            >
              Go Home
            </button>
          </>
        )}
      </div>
      <CancelConfirmation
        show={showCancelConfirmation}
        closePopup={() => setShowCancelConfirmation(false)}
      />
    </div>
  );
};

export default SuccessAppointment;
